import { Stack, TextField } from '@mui/material';
import { type MediaFrame } from '@provision/landing-page-ui';
import { useId } from 'react';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { FormFieldLabel } from 'src/components/Forms/FormFieldLabel/form-field-label';
import { ImageFrameEditor } from 'src/pages/Settings/memberships/components/landing-page-tab/block-fields/image-frame-editor';
import {
  blockFieldName,
  type LandingPageFormValues,
} from 'src/pages/Settings/memberships/components/landing-page-tab/types';
import { IMAGE_URL_FIELD_RULES } from 'src/pages/Settings/memberships/utils/image-url-field-rules';

interface ImageUrlFieldProps {
  index: number;
  prefix: MediaFrame;
  label: string;
  helperText?: string;
  readOnly: boolean;
}

export const ImageUrlField = ({
  index,
  prefix,
  label,
  helperText,
  readOnly,
}: ImageUrlFieldProps) => {
  const { control } = useFormContext<LandingPageFormValues>();
  const inputId = useId();
  const name = blockFieldName(index, `${prefix}ImageUrl`);
  const value = useWatch({ control, name });

  return (
    <Controller
      name={name}
      control={control}
      rules={IMAGE_URL_FIELD_RULES}
      render={({ field, fieldState }) => (
        <Stack spacing={1.5}>
          <Stack>
            <FormFieldLabel htmlFor={inputId}>{label}</FormFieldLabel>
            <TextField
              {...field}
              value={field.value ?? ''}
              id={inputId}
              size="small"
              fullWidth
              disabled={readOnly}
              placeholder="https://example.com/image.jpg"
              error={Boolean(fieldState.error)}
              helperText={fieldState.error?.message ?? helperText}
            />
          </Stack>
          <ImageFrameEditor
            index={index}
            prefix={prefix}
            url={typeof value === 'string' ? value.trim() : ''}
            readOnly={readOnly}
          />
        </Stack>
      )}
    />
  );
};
